<template>
  <div class="container container-shadow register-container">
      <el-form :model="formVal" :rules="formRules" label-position="right" label-width="225px" ref="formVal" class="register-box register-box-width ">

        <el-form-item label="Email" prop="email" class="form-row">
            <el-input type="text" v-model="formVal.email" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Email Confirm" prop="emailConfirm" class="form-row">
            <el-input type="text" v-model="formVal.emailConfirm" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Country Code" class="form-row" prop="phone_country_code">
            <el-select v-model="formVal.phone_country_code" filterable >
              <el-option
                v-for="(item,index) in country_list"
                :value="item.code"
                :label="item.label"
                :key="index"
                >
              </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="Mobile Number" prop="phone" class="form-row" ref="phone">
            <el-input type="text" v-model="formVal.phone" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Verification Code" prop="verify_code" class="form-row captcha-row">
            <el-input type="text" v-model="formVal.verify_code" auto-complete="off"></el-input>
            <img src='' ref="captcha" @click="_captcha()">
        </el-form-item>

        <el-form-item label="Other Contact Number" prop="other_contact_number" class="form-row">
            <el-input type="text" v-model="formVal.other_contact_number" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="Password" prop="password" class="form-row password-row box-form-row">
            <div class="btn-show-password" @click="togglePw" :class="{'open':passType==='text'}"></div>
            <el-input :type="passType" v-model="formVal.password" auto-complete="off"></el-input>
        </el-form-item>

        <div class="form-row form-button">
          <el-button :loading="btnLoading" @click="submitForm('formVal')">Create  account</el-button>
        </div>

        <div class="register-tips">
          <router-link tag="div" :to="{name:'login'}" class="have-account">Already have an account?</router-link>
         <!-- <a target="_blank" href="https://v88.live800.com/live800/chatClient/chatbox.jsp?companyID=803928&configID=6373&jid=9561649295&s=1" class="livechat">Live Chat</a> -->
        </div>
      </el-form>
  </div>
</template>

<script>
import {
  validateEmailIsExist,
  validatePhoneIsExist,
  validatePass,
  validatePhone
} from 'utils/validate'
import sendCode from 'components/sendCode/sendCode'
import { register, sendPasscode, captcha, searchIpArea } from 'service/register'
import _country_list from 'utils/country'
export default {
  beforeRouteEnter(to, from, next) {
    window.vuex_store.commit('set_title', 'Create  Account')
    searchIpArea()
      .then(data => {
        next(vm => vm._setCountryCode(data))
      })
      .catch(() => {
        next()
      })
  },
  data() {
    let validateCheckEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the email again.'))
      } else if (value !== this.formVal.email) {
        callback(new Error('The email address is inconsistent!'))
      } else {
        callback()
      }
    }
    return {
      btnLoading: false,
      sendCode: false,
      sendLoading: false,
      passType: 'password',
      formVal: {
        email: '',
        emailConfirm: '',
        phone_country_code: '',
        phone: '',
        passcode: '',
        verify_code: '',
        other_contact_number: '',
        password: ''
      },
      country_list: _country_list,
      formRules: {
        email: [
          { required: true, message: 'Required.', trigger: 'blur' },
          {
            type: 'email',
            message: 'Invalid email format.',
            trigger: ['blur']
          },
          { validator: validateEmailIsExist, trigger: 'blur' }
        ],
        emailConfirm: [
          { required: true, message: 'Required.', trigger: 'blur' },
          { validator: validateCheckEmail, trigger: 'blur' }
        ],
        phone_country_code: [
          { required: true, message: 'Required.', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Required.', trigger: 'blur' },
          {
            validator: validatePhone,
            trigger: 'blur'
          },
          { validator: validatePhoneIsExist, trigger: 'blur' }
        ],
        passcode: [
          {
            required: true,
            message: 'Please enter the code received.',
            trigger: 'blur'
          }
        ],
        verify_code: [
          {
            required: true,
            message: 'Please enter your Verification Code.',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: 'Required.', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    sendCode
  },
  created() {
    this._captcha()
  },
  methods: {
    _captcha() {
      captcha().then(res => {
        this.$refs.captcha.setAttribute('src', res.url)
      })
    },
    _setCountryCode(data) {
      this.formVal.phone_country_code = data.code ? Number(data.data.code) : ''
    },
    sendPhoneCode() {
      this.$refs.formVal.validateField('phone_country_code', valid => {
        if (valid) {
          return
        }
        this.$refs.formVal.validateField('phone', valid => {
          if (valid) {
            return
          }
          this.$refs.formVal.validateField('verify_code', valid => {
            if (valid) {
              return
            }
            sendPasscode({
              phone: this.formVal.phone,
              tele_code_type: this.formVal.phone_country_code,
              verify_code: this.formVal.verify_code
            }).then(() => {
              this.sendCode = true
            })
          })
        })
      })
    },
    togglePw() {
      if (this.passType === 'password') {
        this.passType = 'text'
      } else {
        this.passType = 'password'
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.btnLoading = true
          register(this.formVal)
            .then(res => {
              this.btnLoading = false
              localStorage.uk_token = res.token
              this.$alert(
                'Your account has been registered successfully , We have sent you a confirmation email.',
                {
                  callback: () => {
                    this.$router.push({ name: 'memberIndex' })
                  }
                }
              )
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else {
          console.log('error submit!')
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';
.box-form-row {
  margin-top: 20px;
  .el-form-item__error {
    position: absolute !important;
    right: -250px;
    top: 1px;
    left: auto;
    width: 240px;
    height: 50px;
    border: solid 1px #0A95FF;
    color: #333333;
    font-size: 12px;
    padding: 12px;
    &:before {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      top: 19px;
      left: -9px;
      border-width: 6px 8px 6px 0;
      border-style: solid solid solid solid;
      border-color: transparent #0A95FF transparent transparent;
    }
    &:after {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      top: 19px;
      left: -8px;
      border-width: 6px 8px 6px 0;
      border-style: solid solid solid solid;
      border-color: transparent #fff transparent transparent;
    }
  }
}
.register-container {
  // height: 482px;
  padding-bottom: 65px;
  .register-box {
    width: 705px;
    min-height: 200px;
    margin: 0 auto;

    .form-row {
      margin-bottom: 20px;
      margin-top: 0;
      .el-form-item__label {
        line-height: 52px;
        padding-right: 20px;
      }
      .el-select {
        display: block;
      }
      .el-form-item__error {
        position: static;
      }
    }

    .form-button {
      padding-left: 175px;
    }
    .passcode-row {
      position: relative;
      input {
        width: 380px;
      }
      button {
        position: absolute;
        right: 0;
        width: 140px;
        height: 52px;
        background-color: #f2f2f2;
        border: none;
        color: #333333;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .captcha-row {
      position: relative;
      input {
        width: 380px;
      }
      img {
        position: absolute;
        top: 0;
        right: 0;
        width: 140px;
        height: 52px;
        background-color: #f2f2f2;
        color: #333333;
        cursor: pointer;
        border: 1px solid #ccc;
        &:hover {
          opacity: 0.8;
        }
      }
    }

    .register-tips {
      margin-top: -10px;
      padding-left: 175px;
      .have-account {
        float: right;
        color: $color-primary;
        line-height: 1;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
        }
      }
      .livechat {
        padding-left: 38px;
        background: url(~assets/img/ico-chat.png) no-repeat;
        color: $color-primary;
        text-decoration: underline;
        &:hover {
        }
      }
    }
  }
}
.register-container .register-box-width {
  width: 755px;
}
.el-message-box__headerbtn {
  z-index: 999;
}
</style>
